import _extends from '@babel/runtime/helpers/esm/extends';
import _objectWithoutProperties from '@babel/runtime/helpers/esm/objectWithoutProperties';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';
import React, { useContext, useMemo, useCallback } from 'react';
import PropTypes from 'prop-types';
import ArrowShortRight from '@elliemae/ds-icons/ArrowShortRight';
import DSButton from '@elliemae/ds-basic/Button';
import Search from '@elliemae/ds-icons/Search';
import { runAll } from '@elliemae/ds-utilities/utils';
import ShuttleSearchBox from './ShuttleSearchBox.js';
import ShuttleInfiniteScrollIndicator from './ShuttleInfiniteScrollIndicator.js';
import ShuttleSourceListItem from './ShuttleListItem/ShuttleSourceListItem.js';
import { ShuttleWrapper, ShuttleHeader, ShuttleHeaderBreadcrumb, ShuttleHeaderSearchToggle, ShuttleList, Overflow, LoadingList, EmptyMessage, ShuttleFooter, ShuttleFooterActions, ShuttleFooterCounter } from '../classedComponents.js';
import ShuttleListPanel from './ShuttleListPanel.js';
import VirtualizedList from './VirtualizedList.js';
import { getActiveIdFromHierarchy } from '../helper.js';
import AnimationContext from '../AnimationState.js';
import SearchState from '../SearchState.js';
import VirtualizedSortableList from './VirtualizedSortableList.js';
import LoadingIndicator from './LoadingIndicator.js';
import '@babel/runtime/helpers/esm/classCallCheck';
import '@babel/runtime/helpers/esm/createClass';
import '@babel/runtime/helpers/esm/assertThisInitialized';
import '@babel/runtime/helpers/esm/inherits';
import '@babel/runtime/helpers/esm/possibleConstructorReturn';
import '@babel/runtime/helpers/esm/getPrototypeOf';
import '@elliemae/ds-classnames';
import '@elliemae/ds-basic/form/TextBox';
import '@elliemae/ds-basic/IndeterminateProgressIndicator';
import '@babel/runtime/helpers/esm/slicedToArray';
import './ShuttleListItem/ActionButtons.js';
import '@elliemae/ds-icons/CloseCircle';
import '@elliemae/ds-icons/ArrowShortReturn';
import './ShuttleListItem/ShuttleListItem.js';
import 'react-spring/web.cjs';
import '@elliemae/ds-basic/TruncatedTooltipText';
import 'react-sortable-hoc';
import '@elliemae/ds-icons/GripperVertical';
import './ShuttleBreadcrumb.js';
import '@elliemae/ds-basic/Breadcrumb';
import '../animation/animationConfig.js';
import './OverflowList.js';
import 'react-window';
import 'react-window-infinite-loader';
import 'react-virtualized-auto-sizer';
import './VirtualizedItem.js';
import 'treetabular';
import 'constate';
import '@elliemae/ds-basic/CircularProgressIndicator';
import 'styled-components';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var noop = function noop() {};

function ShuttleSource(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      _ref$checkedItems = _ref.checkedItems,
      checkedItems = _ref$checkedItems === void 0 ? [] : _ref$checkedItems,
      _ref$hierarchy = _ref.hierarchy,
      hierarchy = _ref$hierarchy === void 0 ? [] : _ref$hierarchy,
      _ref$onMoveItem = _ref.onMoveItem,
      onMoveItem = _ref$onMoveItem === void 0 ? noop : _ref$onMoveItem,
      _ref$onCheckItem = _ref.onCheckItem,
      onCheckItem = _ref$onCheckItem === void 0 ? noop : _ref$onCheckItem,
      _ref$onMoveCheckedIte = _ref.onMoveCheckedItems,
      onMoveCheckedItems = _ref$onMoveCheckedIte === void 0 ? noop : _ref$onMoveCheckedIte,
      _ref$onNavigateTo = _ref.onNavigateTo,
      onNavigateTo = _ref$onNavigateTo === void 0 ? noop : _ref$onNavigateTo,
      _ref$onClearCheckedIt = _ref.onClearCheckedItems,
      onClearCheckedItems = _ref$onClearCheckedIt === void 0 ? noop : _ref$onClearCheckedIt,
      _ref$emptyMessage = _ref.emptyMessage,
      emptyMessage = _ref$emptyMessage === void 0 ? 'No items found' : _ref$emptyMessage,
      _ref$composeSourceIte = _ref.composeSourceItemProps,
      composeSourceItemProps = _ref$composeSourceIte === void 0 ? noop : _ref$composeSourceIte,
      _ref$loading = _ref.loading,
      loading = _ref$loading === void 0 ? false : _ref$loading,
      _ref$onSearch = _ref.onSearch,
      onSearch = _ref$onSearch === void 0 ? noop : _ref$onSearch,
      _ref$onSearchClose = _ref.onSearchClose,
      onSearchClose = _ref$onSearchClose === void 0 ? noop : _ref$onSearchClose,
      _ref$onSearchOpen = _ref.onSearchOpen,
      onSearchOpen = _ref$onSearchOpen === void 0 ? noop : _ref$onSearchOpen,
      _ref$sourceSortable = _ref.sourceSortable,
      sourceSortable = _ref$sourceSortable === void 0 ? false : _ref$sourceSortable,
      _ref$onSortEnd = _ref.onSortEnd,
      onSortEnd = _ref$onSortEnd === void 0 ? noop : _ref$onSortEnd,
      _ref$sourceClearItems = _ref.sourceClearItemsText,
      sourceClearItemsText = _ref$sourceClearItems === void 0 ? 'CLEAR ALL' : _ref$sourceClearItems,
      searchPlaceholder = _ref.searchPlaceholder,
      _ref$renderSourceCoun = _ref.renderSourceCounter,
      renderSourceCounter = _ref$renderSourceCoun === void 0 ? function (amount) {
    return "".concat(amount, " items");
  } : _ref$renderSourceCoun,
      _ref$onGetMoreItems = _ref.onGetMoreItems,
      onGetMoreItems = _ref$onGetMoreItems === void 0 ? function () {} : _ref$onGetMoreItems,
      _ref$moreItemsLoading = _ref.moreItemsLoading,
      moreItemsLoading = _ref$moreItemsLoading === void 0 ? false : _ref$moreItemsLoading,
      _ref$hasNextPage = _ref.hasNextPage,
      hasNextPage = _ref$hasNextPage === void 0 ? false : _ref$hasNextPage;

  var _useContext = useContext(AnimationContext.Context),
      _useContext$state = _useContext.state,
      _useContext$state$isM = _useContext$state.isMovingBack,
      isMovingBack = _useContext$state$isM === void 0 ? false : _useContext$state$isM,
      isMoving = _useContext$state.isMoving;

  var _useContext2 = useContext(SearchState.Context),
      _useContext2$state = _useContext2.state,
      searching = _useContext2$state.searching,
      searchTerm = _useContext2$state.searchTerm,
      setSearchTerm = _useContext2.setSearchTerm,
      resetSearch = _useContext2.reset,
      toggleSearchBox = _useContext2.toggleSearchBox;

  var hashedCheckedItems = useMemo(function () {
    return checkedItems.reduce(function (result, item) {
      return _objectSpread(_objectSpread({}, result), {}, _defineProperty({}, item, true));
    }, {});
  }, [checkedItems]);
  var handleCloseSearch = useCallback(function () {
    setSearchTerm('');
    runAll(resetSearch, onSearchClose)();
  }, [searching]);
  var handleToggleSearch = useCallback(function () {
    toggleSearchBox(!searching);

    if (searching) {
      handleCloseSearch();
    } else {
      onSearchOpen();
    }
  }, [searching]);
  var ComponentList = useMemo(function () {
    return sourceSortable ? VirtualizedSortableList : VirtualizedList;
  }, [sourceSortable]);

  var handleSortEnd = function handleSortEnd(_ref2) {
    var oldIndex = _ref2.oldIndex,
        newIndex = _ref2.newIndex;
    onSortEnd({
      sourceItem: items[oldIndex],
      targetItem: items[newIndex]
    });
  };

  var isEmpty = !items.length;
  var hasContent = !loading && !isEmpty;
  var contentIsEmpty = !loading && isEmpty;
  return /*#__PURE__*/React.createElement(ShuttleWrapper, null, /*#__PURE__*/React.createElement(ShuttleHeader, null, /*#__PURE__*/React.createElement(ShuttleHeaderBreadcrumb, {
    hierarchy: hierarchy,
    onNavigateTo: onNavigateTo
  }), /*#__PURE__*/React.createElement(ShuttleHeaderSearchToggle, {
    buttonType: "text",
    icon: /*#__PURE__*/React.createElement(Search, null),
    onClick: handleToggleSearch,
    containerProps: {
      'data-testid': 'shuttle-header-search-toggle'
    }
  })), /*#__PURE__*/React.createElement(ShuttleList, {
    classProps: {
      showPulse: isMovingBack
    },
    style: {
      pointerEvents: isMoving ? 'none' : null
    }
  }, /*#__PURE__*/React.createElement(ShuttleSearchBox, {
    key: searching,
    isOpen: searching,
    onClose: runAll(function () {
      return toggleSearchBox(false);
    }, handleCloseSearch),
    onFilter: runAll(setSearchTerm, onSearch),
    placeholder: searchPlaceholder,
    value: searchTerm
  }), hasContent ? /*#__PURE__*/React.createElement(Overflow, {
    activeHierarchy: getActiveIdFromHierarchy(hierarchy).id,
    classProps: {
      searching: searching,
      empty: isEmpty
    }
  }, /*#__PURE__*/React.createElement(ComponentList, {
    key: searchTerm,
    helperClass: "drag-helper",
    itemRenderer: function itemRenderer(_ref3) {
      var item = _ref3.item,
          rest = _objectWithoutProperties(_ref3, ["item"]);

      return /*#__PURE__*/React.createElement(ShuttleSourceListItem, _extends({
        "data-testid": "source-list-item"
      }, rest, composeSourceItemProps(item, rest), {
        isChecked: !!hashedCheckedItems[item.id],
        item: item,
        onItemCheck: onCheckItem,
        onMoveToTarget: onMoveItem,
        onNavigateOnSourceTo: onNavigateTo,
        showSortHandler: sourceSortable
      }));
    },
    items: items,
    onSortEnd: handleSortEnd,
    getMoreItems: onGetMoreItems,
    hasNextPage: hasNextPage
  })) : null, contentIsEmpty ? /*#__PURE__*/React.createElement(LoadingList, {
    "data-testid": "shuttle__loading-list"
  }, /*#__PURE__*/React.createElement(EmptyMessage, null, emptyMessage)) : null, loading ? /*#__PURE__*/React.createElement(LoadingList, {
    "data-testid": "shuttle__loading-list"
  }, /*#__PURE__*/React.createElement(LoadingIndicator, null)) : null, /*#__PURE__*/React.createElement(ShuttleListPanel, {
    onClick: onMoveCheckedItems,
    open: checkedItems.length > 1
  }, /*#__PURE__*/React.createElement(ArrowShortRight, null)), moreItemsLoading ? /*#__PURE__*/React.createElement(ShuttleInfiniteScrollIndicator, {
    isOpen: true
  }) : null), /*#__PURE__*/React.createElement(ShuttleFooter, null, /*#__PURE__*/React.createElement(ShuttleFooterActions, null, !!checkedItems.length && /*#__PURE__*/React.createElement(DSButton, {
    buttonType: "link",
    labelText: sourceClearItemsText,
    onClick: onClearCheckedItems
  })), /*#__PURE__*/React.createElement(ShuttleFooterCounter, null, renderSourceCounter(checkedItems.length))));
}

ShuttleSource.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})),
  checkedItems: PropTypes.arrayOf(PropTypes.shape({})),
  hierarchy: PropTypes.arrayOf(PropTypes.shape({})),
  onMoveItem: PropTypes.func,
  onCheckItem: PropTypes.func,
  onMoveCheckedItems: PropTypes.func,
  onNavigateTo: PropTypes.func,
  onClearCheckedItems: PropTypes.func,
  emptyMessage: PropTypes.string,
  composeSourceItemProps: PropTypes.func,
  loading: PropTypes.bool,
  onSearch: PropTypes.func,
  onSearchClose: PropTypes.func,
  onSearchOpen: PropTypes.func,
  sourceSortable: PropTypes.bool,
  onSortEnd: PropTypes.func,
  sourceClearItemsText: PropTypes.string,
  searchPlaceholder: PropTypes.string,
  renderSourceCounter: PropTypes.func,
  onGetMoreItems: PropTypes.func,
  moreItemsLoading: PropTypes.bool,
  hasNextPage: PropTypes.bool
};

export default ShuttleSource;
//# sourceMappingURL=ShuttleSource.js.map
